document.addEventListener("DOMContentLoaded", function () {
  const tabsSections = document.querySelectorAll(".section-grid-tabs");

  tabsSections.forEach((tabsSection, index) => {
    initTabsSection(tabsSection);
    setActiveTab(tabsSection, 0);
    if (index === 0) {
      tabsSection.classList.add("first-grid-tabs");
    }
    if (index === tabsSections.length - 1) {
      tabsSection.classList.add("last-grid-tabs");
    }
  });
});

const clearActiveTabs = (section) => {
  const tabs = section.querySelectorAll(".grid__tab");
  const contents = section.querySelectorAll(".grid__content__tab");
  const images = section.querySelectorAll(".tab__image");

  tabs.forEach((tab) => {
    tab.classList.remove("active");
  });

  contents.forEach((tab) => {
    tab.classList.remove("active");
  });

  images.forEach((tab) => {
    tab.classList.remove("active");
  });
};

const setActiveTab = (section, index) => {
  const tabs = section.querySelectorAll(".grid__tab");
  const contents = section.querySelectorAll(".grid__content__tab");
  const images = section.querySelectorAll(".tab__image");

  tabs[index].classList.add("active");
  contents[index].classList.add("active");
  images[index].classList.add("active");
};

const initTabsSection = (section) => {
  const tabs = section.querySelectorAll(".grid__tab");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function (ev) {
      ev.preventDefault();
      clearActiveTabs(section);
      setActiveTab(section, index);
    });
  });
};
